import { Expose, Transform } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { toEuros } from "@/utils/numberUtils";

export class PointPaidPositionDto extends BaseEntityDto {
  @Expose()
  name: string;

  @Expose()
  @Transform(({ value }) => toEuros(value))
  monthlySalary: number;

  @Expose()
  averagePoints: number;
}
